import React from 'react';

import type { Odds } from '@swf/generated/types/api/sports';

import PriceChangeAlert from '../PriceChangeAlert/PriceChangeAlert';
import PromotionAlert from '../PromotionAlert/PromotionAlert';
import StakeError from '../Stake/components/StakeError/StakeError';

interface Props {
  id: string;
  acceptedOdds?: Odds;
  winRunnerOdds?: Odds;
  shouldDisplayPriceChange: boolean | undefined;
}

const StakeAlerts: React.FC<Props> = ({
  winRunnerOdds,
  acceptedOdds,
  shouldDisplayPriceChange,
  id
}) => (
  <>
    <StakeError fieldName={id} />
    <PromotionAlert fieldName={id} />

    {shouldDisplayPriceChange && (
      <PriceChangeAlert acceptedOdds={acceptedOdds} currentOdds={winRunnerOdds} />
    )}
  </>
);

export default StakeAlerts;
